import type { AdvancedFilters } from './filters'

export const normalizeFilter = (filter: AdvancedFilters): AdvancedFilters => {
  if (filter.filters.length === 0) {
    return { all: true } as unknown as AdvancedFilters
  }

  return filter
}
